export default __webpack_public_path__ + "static/double-9507502f70050deb0f93082cfb1ab055.jpg";